import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';

@Component({
  selector: 'app-fields-interventions-tractors-trailer-width-choice-report',
  templateUrl: './fields-interventions-tractors-trailer-width-choice-report.component.html',
  styleUrls: ['./fields-interventions-tractors-trailer-width-choice-report.component.scss']
})
export class FieldsInterventionsTractorsTrailerWidthChoiceReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  toolbarDs: DataSource;

  @Input()
  dataSource: PivotGridDataSource;

  @Input()
  currentReportType: any;

  @Input()
  reportCurrentViewModes: any;

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  @Input()
  width: number;

  @Input()
  height: number;

  constructor() {
  }

  ngOnInit(): void {

    // Set fields
    this.dataSource.fields([{
      caption: 'BU',
      width: 120,
      dataField: 'business_unit_name',
      area: 'filter',
      allowFiltering: true,
    }, {
      caption: 'Domaine',
      width: 120,
      dataField: 'domain_name',
      area: 'filter',
      allowFiltering: true,
    }, {
      caption: 'Puissance',
      dataField: 'tractor_engine_power',
      allowFiltering: true,
      width: 150,
      area: 'row'
    }, {
      caption: 'Tracteur',
      dataField: 'tractor_name',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Outil',
      dataField: 'trailer_name',
      width: 150,
      area: 'row'
    }, {
      caption: 'Année',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'year',
      area: 'column'
    }, {
      caption: 'Mois',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'month',
      area: 'column'
    }, {
      caption: 'Jour',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'day',
      area: 'column'
    }, {
      caption: 'Largeur de Travail (m)',
      dataField: 'trailer_width',
      visible: true,
      summaryType: 'avg',
      format: (value) => {
        return (value as number / 100).toFixed(2);
      },
      area: 'data'
    }]);

    this.toolbarDs.store().push([{
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.pivotGrid.instance.getFieldChooserPopup().show();
          }
        }
      },
      key: 'filter',
    },
      {
        type: 'update',
        data: {
          options: {
            onClick: () => {
              this.dataSource.reload();
            }
          }
        },
        key: 'refresh',
      }]);
  }

  ngAfterViewInit(): void {
    this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'singleAxis',
      alternateDataFields: false,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      },
      customizeChart: (chartOptions) => {
        chartOptions.valueAxis[0].label = {
          customizeText: (args) => {
            return (args.value / 100).toFixed(2) + ' m';
          }
        };
        return chartOptions; // This line is optional
      },
    });

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.dataSource);
  }

  ngOnDestroy(): void {
  }

  customizeTooltip(args) {
    return {
      html: args.seriesName + ': ' + (args.originalValue / 100).toFixed(2) + ' m'
    };
  }
}
